import React from 'react'
import { Box } from 'grommet'
import TintedImage from './TintedImage'
import BadgeProvider from './BadgeProvider'
import { colors } from 'galarm-config'

const ChatIconSmall = ({ unseenMessages = 0, tintColor = 'primary' }) => {
  const badge = <Box />
  return (
    <Box style={{ padding: 2 }}>
      {unseenMessages ? (
        <BadgeProvider badge={badge} backgroundColor={colors.red}>
          <TintedImage
            tintColor={tintColor}
            src={require('galarm-res/img/web/ic_chat.svg').default}
            height="25px"
          />
        </BadgeProvider>
      ) : (
        <TintedImage
          tintColor={tintColor}
          src={require('galarm-res/img/web/ic_chat.svg').default}
          height="25px"
        />
      )}
    </Box>
  )
}

export default ChatIconSmall
